import * as types from '../constants';

const initialState = {
  isClickedMenuButton: false,
  isHoverMenu: false,
  hotelName: '',
  timezone: '',
  address: '',
  buildingCount: 0,
  roomCount: 0,
  doorlockCount: 0,
  bookingCount: 0,
  staffCount: 0,
  pincodeVersion: '',
  doorlockDeletable: false,
};

const SidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_IS_CLICKED_MENU_BUTTON:
      return {
        ...state,
        isClickedMenuButton: action.payload,
      };
    case types.SET_IS_HOVER_MENU:
      return {
        ...state,
        isHoverMenu: action.payload,
      };
    case types.SET_SIDEBAR_ITEM:
      return {
        ...state,
        ...action.payload,
      };
    case types.SET_HOTEL_ITEM:
      return {
        ...state,
        hotelName: action.payload.hotelName,
        timezone: action.payload.timezone,
        address: action.payload.address,
      };
    default:
      return state;
  }
};

export default SidebarReducer;